export default __webpack_public_path__ + "static/media/eye-clear.2d777ecb.svg";